export const SageBaseUrl = 'https://www.sageone.com/oauth2/auth/central';
